import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'agency'})
export class AgencyPipe implements PipeTransform {

	transform(value: string | number) {
		if (value || value === 0) {
			value = value.toString();
			return value.padStart(4, '0');
		}
		return value;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/agency.pipe.ts